import { computed } from 'vue';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { useHauContractStore } from '@/features/Sparten/hau/useContractStore';
import {
  hasElementarDamage,
  hasGlasDamage,
  isFertighaus,
} from '@/features/Sparten/hau/formConfigs/sharedRenderConditions';
import {
  hasNoElementarGefahren,
  hasNoPreviousDamage,
} from '@/features/Sparten/shared/contractDehydration/property/conditionalRequestDefinitions';

export const hasNoFertighaus: ConditionalRequestDefinition = {
  if: computed(() => !isFertighaus.value),
  drop: ['fertighaus'],
};

export const hasNoGefahrErheblicheUmstaende: ConditionalRequestDefinition = {
  if: computed(
    () => !useHauContractStore().gefahrerheblicheUmstaende.vorhanden,
  ),
  drop: ['gefahrerheblicheUmstaende.memofeld'],
};

export const hasNoElementarDamageConditional: ConditionalRequestDefinition = {
  if: computed(() => !hasElementarDamage.value),
  drop: ['vorschaden.elementarAnzahl', 'vorschaden.elementarEntschaedigung'],
};

export const hasNoGlasDamageConditional: ConditionalRequestDefinition = {
  if: computed(() => !hasGlasDamage.value),
  drop: ['vorschaden.glasAnzahl', 'vorschaden.glasEntschaedigung'],
};

export const hauContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  [
    hasNoElementarGefahren,
    hasNoFertighaus,
    hasNoGefahrErheblicheUmstaende,
    hasNoElementarDamageConditional,
    hasNoGlasDamageConditional,
    hasNoPreviousDamage,
  ];
